export class StoreFuncionalityCodesModel {
    advanceCode = 'ANTICIPOS';
    invoices = 'GEST_FACT';
    portfilioCode = 'EST_CART';
    statementAccountCode = 'EST_CUENTA';

}